
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-16 max-w-4xl">
        {/* ヘッダー */}
        <div className="mb-12">
          <Button
            variant="outline"
            onClick={() => navigate("/")}
            className="mb-8 transform -rotate-1 hover:rotate-0 transition-all duration-300"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            トップページに戻る
          </Button>
          
          <div className="transform rotate-1">
            <h1 className="text-4xl md:text-5xl font-serif text-elegant mb-4 tracking-[0.1em]">
              プライバシーポリシー
            </h1>
            <div className="w-24 h-1 bg-kawatteru-accent-purple transform -rotate-2"></div>
          </div>
        </div>

        {/* コンテンツ */}
        <div className="prose prose-elegant max-w-none">
          <div className="bg-white/80 backdrop-blur-sm p-8 rounded-lg elegant-shadow transform -rotate-0.5">
            
            <section className="mb-8">
              <h2 className="text-2xl font-medium text-elegant mb-4 transform rotate-0.5">
                個人情報の取り扱いについて
              </h2>
              <p className="leading-relaxed text-elegant/80 mb-4">
                当サイト「Kawatteru」（以下、「当サイト」）では、ユーザーの個人情報の保護を重要視し、
                個人情報保護法を遵守して適切な取り扱いを行っています。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-medium text-elegant mb-4 transform -rotate-0.5">
                収集する情報について
              </h2>
              <p className="leading-relaxed text-elegant/80 mb-4">
                当サイトでは、サービスの向上や利用状況の分析のため、以下の情報を収集する場合があります：
              </p>
              <ul className="list-disc pl-6 space-y-2 text-elegant/80">
                <li>アクセス情報（IPアドレス、ブラウザ情報、アクセス日時など）</li>
                <li>Cookie情報</li>
                <li>お問い合わせフォームに入力された情報</li>
              </ul>
            </section>

            <section className="mb-8 bg-kawatteru-muted-yellow/20 p-6 rounded-lg transform rotate-1">
              <h2 className="text-2xl font-medium text-elegant mb-4">
                Googleアナリティクスの使用について
              </h2>
              <p className="leading-relaxed text-elegant/80 mb-4">
                当サイトでは、Googleのアクセス解析ツール「Googleアナリティクス」を使用しています。
                Googleアナリティクスは、Cookieを使用してデータを収集しますが、
                このデータは匿名化されており、個人が特定されることはありません。
              </p>
              <p className="leading-relaxed text-elegant/80 mb-4">
                Cookieを無効にすることでデータ収集を拒否できますので、
                使用ブラウザの設定を確認してください。
              </p>
              <p className="leading-relaxed text-elegant/80">
                詳細については、
                <a 
                  href="https://policies.google.com/technologies/partner-sites"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-kawatteru-accent-purple hover:underline"
                >
                  Googleポリシー、規約ページ
                </a>
                をご参照ください。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-medium text-elegant mb-4 transform rotate-0.5">
                個人情報の利用目的
              </h2>
              <p className="leading-relaxed text-elegant/80 mb-4">
                収集した個人情報は、以下の目的で利用いたします：
              </p>
              <ul className="list-disc pl-6 space-y-2 text-elegant/80">
                <li>サイトの運営・管理</li>
                <li>コンテンツの改善・向上</li>
                <li>お問い合わせへの対応</li>
                <li>統計データの作成（匿名化処理後）</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-medium text-elegant mb-4 transform -rotate-0.5">
                個人情報の第三者提供
              </h2>
              <p className="leading-relaxed text-elegant/80">
                当サイトでは、法令に基づく場合を除き、
                ユーザーの同意なく個人情報を第三者に提供することはありません。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-medium text-elegant mb-4 transform rotate-0.5">
                免責事項
              </h2>
              <p className="leading-relaxed text-elegant/80">
                当サイトのコンテンツについては、可能な限り正確な情報を掲載するよう努めておりますが、
                その内容の正確性や安全性を保証するものではありません。
                当サイトに掲載された内容によって生じた損害等については、一切の責任を負いかねます。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-medium text-elegant mb-4 transform -rotate-0.5">
                プライバシーポリシーの変更
              </h2>
              <p className="leading-relaxed text-elegant/80">
                当サイトでは、プライバシーポリシーを随時見直し、改善に努めます。
                変更があった場合には、当ページにて告知いたします。
              </p>
            </section>

            <section className="text-center pt-8 border-t border-elegant/20">
              <p className="text-sm text-elegant/60">
                制定日：2025年6月4日<br />
                最終更新日：2025年6月4日
              </p>
            </section>

          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
